import React, { FC } from 'react'
import { ProgressBar } from '@blueprintjs/core'
import css from './samllProgressBar.module.scss'
type TProps = {
  progressPercent: number
}

const SmallProgressBar: FC<React.PropsWithChildren<TProps>> = ({ progressPercent }) => {
  return (
    <>
      <div className={css.wrapper}>
        <ProgressBar
          value={progressPercent / 100}
          stripes={false}
          className={css.imagesProgressBar}
        />
      </div>
      <div className={css.percentage}>
        {progressPercent === 100 ? progressPercent : progressPercent.toFixed(2)}%
      </div>
    </>
  )
}

export default SmallProgressBar
